import { useState, useEffect } from 'react'
import axios from 'axios'
import MyQrcode from '../../../components/general/qrcode'
import AccessPlugin from './accessPlugin'
import DisableDeepseek from './disableDeepseek'

export default function ChatbotConfig() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [chatbotConfig, setChatbotConfig] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAccessAddressVisible, setIsAccessAddressVisible] = useState(false)
  const [isAccessPluginVisible, setIsAccessPluginVisible] = useState(false)
  const [isDisableDeepseekVisible, setIsDisableDeepseekVisible] = useState(false)
  const baseUrl = process.env.NODE_ENV === 'production' ? 'https://ai.yunzhaosoft.com/' : 'http://localhost:3009/'

  const getChatbotConfig = () => {
    axios.post('/p/chatbot/config/get', {
      merchant_oid: merchantOid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setChatbotConfig(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getChatbotConfig()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid])

  const previewAccessAddress = () => {
    setIsAccessAddressVisible(true)
    setPropsData({ accessAddress: baseUrl + merchantOid})
  }

  const previewPluginAccess = () => {
    setIsAccessPluginVisible(true)
  }

  const handleDisableDeepseek = () => {
    setIsDisableDeepseekVisible(true)
    setPropsData({ info: chatbotConfig })
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">配置信息</div>
        </div>

        <div className='public-main-style'>
          <div className='public-main-style4'>
            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>访问地址</div>
                  <div className='public-main-style4-item-description'>点击查看可复制访问链接和下载二维码，可在微信小程序或公众号跳转访问</div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={previewAccessAddress}>查看</div>
                </div>
              </div>
            </div>
          </div>

          <div className='public-main-style4'>
            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>插件接入</div>
                  <div className='public-main-style4-item-description'>通过在网站中嵌入一行 {"<script>"}，即可在页面右下角显示 AI 客服入口。</div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={previewPluginAccess}>接入</div>
                </div>
              </div>
            </div>
          </div>

          <div className='public-main-style4'>
            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>禁用deepseek回答，采用兜底话术</div>
                  <div className='public-main-style4-item-description'>
                    {chatbotConfig.disable_deepseek ? (
                      <>
                        已禁用
                        {chatbotConfig.fallback_msg && (
                          <> | {chatbotConfig.fallback_msg}</>
                        )}
                      </>
                    ) : (
                      <>未禁用</>
                    )}
                  </div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={handleDisableDeepseek}>设置</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isAccessAddressVisible && <MyQrcode
        data={propsData}
        isOpen={isAccessAddressVisible}
        isCancel={() => { setIsAccessAddressVisible(false) }}
      />}
      {isAccessPluginVisible && <AccessPlugin
        isOpen={isAccessPluginVisible}
        isCancel={() => { setIsAccessPluginVisible(false) }}
      />}
      {isDisableDeepseekVisible && <DisableDeepseek
        data={propsData}
        getChatbotConfig={getChatbotConfig}
        isOpen={isDisableDeepseekVisible}
        isCancel={() => { setIsDisableDeepseekVisible(false) }}
      />}
    </div>
  )
}
